import { ComponentProps } from 'react';

import { cva, MergeVariantProps, VariantProps } from '@/ui/cva';

const variants = cva({
    base: 'scroll-mt-[76px] lg:scroll-mt-[92px]',
    variants: {
        color: {
            white: 'bg-white',
            lightgray: 'bg-gray-50',
            darkgray: 'dark bg-gray-800 text-white',
            black: 'dark bg-black text-white',
        },
        padding: {
            none: undefined,
            reduced: 'py-sm md:py-md lg:py-lg',
            normal: 'py-md md:py-lg lg:py-2xl',
        },
    },
    defaultVariants: {
        padding: 'normal',
    },
});

export type SectionVariantProps = VariantProps<typeof variants>;

export type SectionProps = MergeVariantProps<
    ComponentProps<'section'>,
    SectionVariantProps
>;

export function Section({ color, padding, ...props }: SectionProps) {
    return (
        <section
            {...props}
            className={variants({ ...props, color, padding })}
        />
    );
}
